// src/features/aws/getAWSVmLogsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import httpInterceptor from '../../common/APIConfig'

// Async thunk for fetching AWS VM Logs
export const getAWSVmLogs = createAsyncThunk(
  'awsVmLogs/fetch',
  async ({ accountId, instanceId, tag }, { rejectWithValue }) => {
    try {
      const response = await httpInterceptor.get(`/resources/aws/ec2-logs?account=${accountId}&instance=${instanceId}&tag=${tag}`, {
       // params: { account: accountId, instance: instanceId, tag }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || 'Error fetching AWS VM logs'
      );
    }
  }
);

const getAWSVmLogsSlice = createSlice({
  name: 'awsVmLogs',
  initialState: {
    data: null,
    loading: false,
    error: null
  },
  reducers: {
    resetAWSVmLogs: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAWSVmLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAWSVmLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAWSVmLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { resetAWSVmLogs } = getAWSVmLogsSlice.actions;

export default getAWSVmLogsSlice.reducer;
